import React from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Stack from '@mui/material/Stack';

export default function Toast({ toasts = [], removeToast }) {
  return (
    <Stack spacing={1} sx={{ position: 'fixed', bottom: 24, right: 24, zIndex: 2000 }}>
      {toasts.map((t) => (
        <Snackbar
          key={t.id}
          open
          onClose={() => removeToast(t.id)}
          autoHideDuration={t.duration || 3000}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
          sx={{ position: 'relative', bottom: 'auto', right: 'auto' }}
        >
          <Alert
            onClose={() => removeToast(t.id)}
            severity={t.type === 'error' ? 'error' : t.type === 'success' ? 'success' : t.type === 'warning' ? 'warning' : 'info'}
            variant="filled"
            sx={{ minWidth: 280 }}
          >
            {t.text}
          </Alert>
        </Snackbar>
      ))}
    </Stack>
  );
}
